export class LibraryVideo {
  source: string;
  name: string;

  constructor(image: LibraryVideo = null) {
    if (image == null) {
      this.source = "";
      this.name = "";
    } else {
      this.source = image.source;
      this.name = image.name;
    }
  }
}
